import {
  FORMAT_TYPES,
  TAG_TYPES,
  TAG_TO_FORMAT_MAP,
  ASSIST_FORMAT_TYPES,
  LINE_SEPARATOR,
  ATTRIBUTE_ORDER,
  BLOCKLEVELTYPES
} from "../index.js";

const GROUP_TYPES = [TAG_TYPES.UL, TAG_TYPES.OL, TAG_TYPES.BLOCKQUOTE];

/**
 * Serialize HTML content to structured data.
 *
 * This function takes an HTML content and converts it into a structured data format,
 * preserving the content and its attributes for further processing or storage.
 *
 * @param {string} htmlContent - The HTML content to be serialized.
 *
 * @returns {Object} The structured data representation of the HTML content.
 */
export function serializeHTML(htmlStr = "", readOnly = false) {
  const parser = new DOMParser();
  const html = parser.parseFromString(htmlStr, "text/html");
  const nodes = html.body.childNodes;
  if (!nodes.length) return "";
  let ops = [];
  nodes.forEach((node, index) => {
    const type = node.nodeName.toLowerCase();
    if (
      BLOCKLEVELTYPES.includes(type) ||
      node.classList.contains("ql-code_block")
    ) {
      let attributes = {};
      if ([TAG_TYPES.H1, TAG_TYPES.H2, TAG_TYPES.H3].includes(type)) {
        attributes = {
          header: ASSIST_FORMAT_TYPES[TAG_TO_FORMAT_MAP[type]],
          align: node.dataset?.align?.toLowerCase() || ""
        };
        serializeInlineNodes(node.childNodes, ops);
        ops.push({
          insert: "\n",
          attributes: attributes
        });
      } else if (
        GROUP_TYPES.includes(type) ||
        node.classList.contains("ql-code_block")
      ) {
        let attributes = {};
        if ([TAG_TYPES.UL, TAG_TYPES.OL].includes(type)) {
          attributes.list = TAG_TO_FORMAT_MAP[type];
        } else if (type === TAG_TYPES.BLOCKQUOTE) {
          attributes[TAG_TO_FORMAT_MAP[type]] = true;
        } else {
          attributes[FORMAT_TYPES.CODE] = true;
        }
        node.childNodes.forEach((node) => {
          serializeInlineNodes(node.childNodes, ops);
          let align = "";
          if (node.dataset?.align) {
            align = node.dataset.align.toLowerCase();
          }
          ops.push({
            attributes: { ...attributes, align },
            insert: "\n"
          });
        });
      }
    } else if (type === TAG_TYPES.P) {
      serializeInlineNodes(node.childNodes, ops);
      let align = "";
      if (node.dataset?.align) {
        align = node.dataset.align.toLowerCase();
      }
      ops.push({
        attributes: {
          align: align
        },
        insert: "\n"
      });
    } else if (node.dataset?.type) {
      /** serialization for custom components*/
      const customType = node.dataset.type;
      const customData = node.dataset[customType];
      ops.push({
        insert: { [customType]: customData ? JSON.parse(customData) : {} }
      });
      if (!readOnly) ops.push({ insert: "\n" });
    }
  });
  return ops;
}

function serializeInlineNodes(nodes = [], ops, shouldPush) {
  nodes &&
    nodes.forEach((node) => {
      serializeNodes([node], {}, ops, shouldPush);
    });
}

function getParsedBlock(customData) {
  if (customData) {
    try {
      return JSON.parse(customData);
    } catch (e) {
      return {};
    }
  } else {
    return {};
  }
}

function serializeNodes(nodes = [], obj, ops, shouldPush = true) {
  nodes.length > 0 &&
    nodes.forEach((node) => {
      const type = node.nodeName.toLowerCase();
      obj.attributes = obj.attributes || {};
      if (node.style?.color) {
        obj.attributes.color = node.style.color;
      }
      if (ATTRIBUTE_ORDER.includes(type)) {
        if (type === TAG_TYPES.A) {
          const customBlockData = node.dataset[TAG_TO_FORMAT_MAP[type]];
          obj.attributes[TAG_TO_FORMAT_MAP[type]] =
            getParsedBlock(customBlockData);
        } else {
          obj.attributes[TAG_TO_FORMAT_MAP[type]] = true;
        }
        serializeNodes(node.childNodes, obj, ops, shouldPush);
      } else if (node.dataset?.type) {
        const customType = node.dataset.type;
        const customData = node.dataset[customType];
        obj.insert = {};
        obj.insert[customType] = getParsedBlock(customData);
        ops.push(Object.assign({}, obj));
        // serializeNodes(node.childNodes, obj, ops, false);
      } else if (type === TAG_TYPES.TEXT_HASH) {
        if (!shouldPush) return;
        // obj.insert = typeof obj.insert !== 'undefined' ? `${obj.insert}${node.text}` : node.text;
        const text = node.nodeValue || "";
        if (text.split("\n").length > 1) {
          let arr = text.trim().split("\n");
          arr.forEach((text) => {
            ops.push(
              {
                insert: text,
                attributes: obj.attributes
                  ? Object.assign({}, obj.attributes)
                  : ""
              },
              {
                insert: LINE_SEPARATOR
              }
            );
          });
        } else {
          ops.push({
            insert: text,
            attributes: obj.attributes ? Object.assign({}, obj.attributes) : ""
          });
        }
      } else if (!node.childNodes?.length) {
        ops.push(Object.assign({}, obj));
      }
    });
}
